import { useState, useEffect } from 'react';

interface SophisticatedCarouselProps {
  images: string[];
  interval?: number;
  className?: string;
}

const SophisticatedCarousel = ({ images, interval = 7500, className = "" }: SophisticatedCarouselProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval]);

  return (
    <div className={`sophisticated-carousel ${className}`}>
      {images.map((image, index) => (
        <div
          key={index}
          className={`sophisticated-slide ${index === currentIndex ? 'active' : ''}`}
        >
          <img
            src={image}
            alt={`Luxury lifestyle in Brazil ${index + 1}`}
            className="sophisticated-image"
          />
        </div>
      ))}
      
      {/* Overlay elegante sem elementos visuais */}
      <div className="sophisticated-overlay"></div>
    </div>
  );
};

export default SophisticatedCarousel;